<template>
    <div id="sdk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/productList' }">产品列表</el-breadcrumb-item>
            <el-breadcrumb-item>下载SDK</el-breadcrumb-item>
        </el-breadcrumb>
        <p class="title">下载SDK
        </p>
        <div class="Sdk">
            <div>

                <template>
                    <el-table
                            :data="tableData"
                            style="width: 100%">
                        <el-table-column
                                prop="pro_name"
                                align="center"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="系统">
                            <template slot-scope="scope">
                                <img :src="scope.row.pro_system" alt="img"/>
                            </template>

                        </el-table-column>
                        <el-table-column
                                prop="pro_Instruction"
                                align="center"
                                width="350"
                                label="说明">
                        </el-table-column>
                        <el-table-column
                                align="center"
                                label="文档"
                        >
                            <template slot-scope="scope">
                                <el-button type="text" @click="toActive(scope.row.pro_document)" size="mini">查看文档
                                </el-button>
                            </template>

                        </el-table-column>
                        <el-table-column
                                prop="pro_operat"
                                align="center"
                                width="350"
                                label="操作">
                            <template slot-scope="scope">
                                <!--<img :src="scope.row.pro_operat" alt="img" @click="downloadUrl(scope.row.address)" />-->
                                <el-button type="primary" size="mini" @click="downloadUrl(scope.row.address)">下载
                                    <i class="el-icon-download" style="font-weight: 900"></i>
                                </el-button>
                                <span v-if="scope.row.index == 0">
                  <el-button type="primary" size="mini"
                             v-if="licenseStatus == 0 || licenseStatus == 3 || licenseStatus == 4" @click="open3">license申请</el-button>
                <el-button type="default" size="mini" v-if="licenseStatus == 1" disabled>审核中</el-button>
                  <span v-if="licenseStatus == 2">
                  <el-button type="primary" size="mini" @click="licenseDownload">license下载 <i class="el-icon-download"
                                                                                              style="font-weight: 900"></i></el-button>
                    <a class="expiration" @click="dialogVisible = true">失效日期</a>
                  </span>
                </span>
                            </template>
                        </el-table-column>

                        <!-- <el-table-column
                           align="center"
                           label="说明">
                           <template slot-scope="scope">
                             {{scope.row.pro_type}}
                           </template>
                         </el-table-column>-->
                    </el-table>
                </template>
            </div>
        </div>
        <el-dialog
                title="License失效日期"
                :visible.sync="dialogVisible"
                width="30%"
        >
            <span>当前License有效期截止到 {{this.licenseData.expire_time}}<br>
                如需申请正式版，请发送邮件至<a href="Mailto:http://orion@ainirobot.com">sunjianan@ainirobot.com</a><br>
                邮件内容需包含：联系人、联系电话、公司简介、产品简介、SDK集成用途信息。
            </span>
            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>
<script>
    import qs from 'qs'
    import {getUserId} from '@/api'
    import {licenseInfoApi, licenseSubApi, licenseDownloadApi} from '@/api/hardIndex.js'

    export default {
        data() {
            return {
                tableData: [
                    {
                        index: 0,
                        pro_name: '智能硬件语音SDK',
                        pro_system: '../../../../static/images/sdkimg.png',
                        pro_Instruction: '智能硬件使用的SDK，SDK作为OVS的桥梁，实现ASR，NLU，TTS整合能力，SDK内包含demo以及可集成SDK',
                        pro_document: '/tutor/ASDK',
                        pro_operat: '../../../../static/images/download.png',
                        // address: 'http://dlbcdn.update.ainirobot.com/open/sdk/sparta-release.aar'
                        address: window.location.host.includes('opentw.ainirobot.com') ? 'http://jp-dlbcdn.update.ainirobot.com/open/sdk/Orion_OS_SDK_taiwan(All_In_One).zip' : 'http://dlbcdn.update.ainirobot.com/open/sdk/Orion_OS_SDK(All_In_One).zip'
                    },
                    // {
                    //     index: 1,
                    //     pro_name: '智能硬件SDK-Demo',
                    //     pro_system: '../../../../static/images/sdkimg.png',
                    //     pro_Instruction: '智能硬件集成OS组件库与服务器的示例Demo',
                    //     pro_document: '/tutor/ASDK',
                    //     pro_operat: '../../../../static/images/download.png',
                    //     address: 'http://dlbcdn.update.ainirobot.com/open/sdk/KratosDemo.zip'
                    //     // address: 'http://dlbcdn.update.ainirobot.com/open/sdk/KratosDemo.zip'
                    // },
                    {
                        index: 2,
                        pro_name: 'Android移动端语音伴侣SDK',
                        pro_system: '../../../../static/images/sdkimg.png',
                        pro_Instruction: 'Android移动端配合智能硬件使用的SDK，可配合智能硬件进行配网并提供技能商店展示等功能，SDK内包含demo以及可集成SDK',
                        pro_document: '/tutor/access',
                        pro_operat: '../../../../static/images/download.png',
                        address: 'http://dlbcdn.update.ainirobot.com/open/sdk/Android_OrionSDK_Demo.zip'
                        // address: 'http://dlbcdn.update.ainirobot.com/open/sdk/android-sdk.aar'
                    },
                    {
                        index: 3,
                        pro_name: 'iOS移动端语音伴侣SDK',
                        pro_system: '../../../../static/images/sdkimg2.png',
                        pro_Instruction: 'iOS移动端配合智能硬件使用的SDK，可配合智能硬件进行配网并提供技能商店展示等功能，SDK内包含demo以及可集成SDK',
                        pro_document: '/tutor/env',
                        pro_operat: '../../../../static/images/download.png',
                        address: 'http://dlbcdn.update.ainirobot.com/open/sdk/iOS_OrionSDK_Demo.zip'
                        // address: 'http://dlbcdn.update.ainirobot.com/open/sdk/OrionSDK-iOS-.zip'
                    },
                ],
                user_id: '',
                licenseStatus: 5,
                licenseData: {
                    package_name: '',
                    licence_file: '',
                    expire_time: '',
                    status: ''
                },
                dialogVisible: false,
                client_id: ''
            }
        },
        created() {
            this.getUserId()
        },
        methods: {
            async licenseDownload() {
                let params = {
                    'user_id': this.user_id,
                    'client_id': this.client_id
                }
                let res = await licenseDownloadApi(params)
                if (res.data.code == 200) {
                    window.location.href = res.data.data.licence_file
                } else {
                    if (res.data.errors.data) {
                        this.$message.error(res.data.errors.data)
                    } else {
                        this.$message.error('license下载失败')
                    }
                }
            },
            // handleClose(done) {
            //     this.$confirm('确认关闭？')
            //         .then(_ => {
            //             done();
            //         })
            //         .catch(_ => {});
            // },
            open3() {
                this.$prompt('系统将根据您的包名信息生成License文件，运营24小时内审核通过后，您可以通过该页面进行下载，测试版license仅提供30天试用期', 'License申请', {
                    confirmButtonText: '提交申请',
                    // inputPattern: /([^\s])/g,
                    inputPlaceholder: '请填写Android包名',
                    inputValidator: (value) => {
                        if (!value) {
                            return false
                        }
                        if (/\s/g.test(value)) {
                            return false
                        } else {
                            return true
                        }
                    },
                    inputErrorMessage: '包名不能为空，不能有空格',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    let data = {
                        'user_id': this.user_id,
                        client_id: this.$route.query.client_id,
                        'package_name': value
                    }
                    this.licenseSub(JSON.stringify(data))

                    // this.$message({
                    //     type: 'success',
                    //     message: '你的邮箱是: ' + value
                    // });
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消输入'
                    // });
                });
            },
            async licenseSub(data) {//获取用户id skillId
                let res = await licenseSubApi(data)
                if (res.data.code == 200) {
                    this.$message.success('提交成功，请等候审核')
                    this.licenseInfo()
                } else {
                    if (res.data.errors.data) {
                        this.$message.error(res.data.errors.data)
                    } else {
                        this.$message.error('提交失败，请稍后重试')
                    }
                }

            },
            async getUserId() {//获取用户id skillId
                let res = await getUserId()
                this.user_id = res.data.data.id
                this.client_id = this.$route.query.client_id
                this.licenseInfo()
            },
            async licenseInfo() {
                let params = {
                    'user_id': this.user_id,
                    'client_id': this.client_id
                }
                let res = await licenseInfoApi(params)
                if (res.data.code == 200) {
                    // 审核状态 0:未提交 1:审核中 2:审核通过 3:审核拒绝 4 审核过期
                    // this.licenseStatus = 0
                    this.licenseData = res.data.data
                    // this.licenseData.expire_time = '2018-08-01'
                    this.licenseStatus = res.data.data.status
                } else {
                    if (res.data.errors.data) {
                        this.$message.error(res.data.errors.data)
                    } else {
                        this.$message.error('license审核信息查询失败')
                    }
                }
            },
            toActive(row) {
                //this.$store.dispatch("changeA",row);
                this.$router.push(row)
            },
            downloadUrl(address) {
                window.location.href = address;
            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    #sdk {
        background: #fff;
        .title {
            height: 64px;
            line-height: 64px;
            padding-left: 30px;
            font-size: 16px;
            font-weight: 800;
            color: #2e4d79;
            border-bottom: 1px solid #f5f5f5;
            border-left: 2px solid #010202;
        }
        .Sdk {
            padding: 20px 30px;
            p {
                height: 50px;
                line-height: 50px;
                color: #666;
                font-size: 14px;
            }
            .el-table__body .el-table__row td:nth-of-type(2) .cell img {
                width: 21px;
                height: 24px;
            }
            .el-table__body .el-table__row td:nth-of-type(5) .cell img {
                width: 55px;
                height: 25px;
            }
            .el-table__body .el-table__row td:nth-of-type(4) span {
                color: #077eec;
                font-size: 14px;
            }
            .el-table__body .el-table__row td:nth-of-type(4):hover {
                color: #077eec;
                font-size: 14px;
                cursor: pointer;
            }
            .el-table__body .el-table__row td:nth-of-type(5) .cell img {
                width: 55px;
                height: 25px;
                cursor: pointer;
            }
            .expiration {
                font-size: 12px;
                text-decoration: none;
                cursor: pointer;
            }
        }
        .el-message-box {
            width: 460px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/hardware/pro/SDK.vue